import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { globalVariablesServer} from '../globals';

@Injectable({
  providedIn: 'root'
})
export class AddfriendService {
  private headers: HttpHeaders;
  constructor(private http: HttpClient) {this.headers = new HttpHeaders({ 
    'Content-Type': 'application/json; charset=utf-8',
    "Access-Control-Allow-Origin": "*", 
    "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token, Accept, Authorization, X-Request-With",
    "Access-Control-Allow-Credentials" : "true",
    "Access-Control-Allow-Methods" : "GET, POST, DELETE, PUT, OPTIONS, TRACE, PATCH, CONNECT"  
  
  }); }

  ShowCity() {  
    return this.http.get(globalVariablesServer.apiurl + 'api/City', { headers: this.headers });
  }

  Save(paramdata){
    return this.http.post(globalVariablesServer.apiurl + 'api/ApiAppUsers/AddFriends',paramdata, { headers: this.headers });
  }




}
